import pointsWithinPolygon from "@turf/points-within-polygon";
import PostcodePoints from "../data/postcodes.json";
import { getPolygonBounds } from "./utils";
import { point, featureCollection } from "@turf/helpers";

class PostcodesService {
    static calculateHouseholds(poly) {
        return new Promise((resolve) => {
            const box = getPolygonBounds(poly);

            const pointsInBox = PostcodePoints.filter((point) => {
                const [_, lng, lat] = point;
                return lng > box[0] && lng < box[2] && lat > box[1] && lat < box[3];
            }).map((item) => {
                const [postcode, lng, lat, count] = item;
                return point([lng, lat], { postcode, count });
            });

            const pointsInPoly = pointsWithinPolygon(featureCollection(pointsInBox), poly);
            const households = pointsInPoly.features.reduce((acc, item) => acc + item.properties.count, 0);

            resolve(households);
        });
    }
}

export default PostcodesService;
